import React, { useLayoutEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { HeadlineStory, Story } from 'pages/dashboard/CaStories'

const HomepageStories = ({ stories, setHomePageStoriesIsLoaded }) => {
  useLayoutEffect(() => {
    setHomePageStoriesIsLoaded(!!stories)
  }, [stories])

  if (!stories) {
    return null
  }

  stories.sort((uno, dos) => uno.position - dos.position)

  return (
    <Grid container spacing={2} className='bg-ghost-grey' style={{ marginTop: 0 }}>
      <Hidden xsDown>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <HeadlineStory {...stories[0]} />
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid item>
          <Story {...stories[0]} />
        </Grid>
      </Hidden>
      {stories.slice(1, 9).map((story) => (
        <Grid key={story.id} item xs={12} sm={6} md={4} lg={4}>
          <Story {...story} />
        </Grid>
      ))}
      {stories.length > 9 && (
        <Hidden only='sm'>
          <Grid key={stories[9].id} item xs={12} sm={6} md={4} lg={4}>
            <Story {...stories[9]} />
          </Grid>
        </Hidden>
      )}
    </Grid>
  )
}

export default HomepageStories
